import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    card: {
        maxWidth: '100%',
        width: '1000px',
        minHeight: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: theme.spacing(2),
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    contentCard: {
        maxWidth: '100%',
        width: '1000px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: theme.spacing(2),
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 'none',
        backgroundColor: '#fafafa'
    }
}));

const ResolveSubscriptionError = () => {
    const classes = useStyles();

    return (
        <CardContent>
            <Card
                className={classes.contentCard}
                variant="outlined"
            >
                <CardContent>
                    <Typography variant="h4" className={classes.cardHeader}>
                        Error resolving marketplace offer. Please return to the Saas subscription page in the Azure portal and try again.
                    </Typography>
                </CardContent>
            </Card>
        </CardContent>
    );
};

export default ResolveSubscriptionError;